'use strict';
(() => {
  const header = document.querySelector('.sc-header-wrap .site-header');
  if (!header) return;
  const home = document.body.dataset.scPage === 'index';
  const update = () => {
    const visible = !home || window.scrollY > 0;
    header.classList.toggle('is-visible', visible);
    header.inert = !visible;
    if (visible) header.removeAttribute('aria-hidden');
    else header.setAttribute('aria-hidden', 'true');
  };
  const measure = () => document.documentElement.style.setProperty('--header-offset', `${header.offsetHeight + 16}px`);
  let pending = false;
  window.addEventListener('scroll', () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { update(); pending = false; });
  }, { passive: true });
  window.addEventListener('pageshow', update);
  window.addEventListener('hashchange', update);
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);
  else window.addEventListener('resize', measure);
  measure(); update();
})();
